import React, { useState, useMemo } from "react"
import {
    Box,
    FormControl,
    Select,
    MenuItem,
    ListSubheader,
    TextField
} from "@mui/material"
import { KeyboardArrowDown } from "@mui/icons-material"
import { sxSelect, sxMenuPaper } from "./SxPesquisarCond"

const Teste = (obj, searchText) => {
    const option = obj.id_central.toLowerCase() + " - " + obj.nome.toLowerCase()
    return option.indexOf(searchText.toLowerCase()) > -1
}

export default function PesquisarCond({ name, options, label = "descricao", value = "id", onChange, open, defaultValue }) {
    const [searchText, setSearchText] = useState("")

    const [selectedValue, setSelectedValue] = useState(defaultValue || "")

    const handleChange = (event) => {
        setSelectedValue(event.target.value)
        onChange(event)
        setTimeout(() => {
            setSelectedValue("")
            setSearchText("")
        }, 200)
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            if (selectedValue === "") {
                setSelectedValue(displayedOptions[0][value])
                onChange({ target: { value: displayedOptions[0][value] } })
            }
            setTimeout(() => {
                setSelectedValue("")
                setSearchText("")
            }, 200)
        }
    }

    const displayedOptions = useMemo(
        () => options.filter((option) => Teste(option, searchText)),
        [searchText]
    )

    return (
        <Box >
            {options &&
                <FormControl sx={{ width: '300px', height: '28px', color: 'black' }}>
                    <Select
                        name={name}
                        sx={sxSelect}
                        value={selectedValue}
                        MenuProps={{
                            PaperProps: { sx: sxMenuPaper },
                            sx: { '& .Mui-selected': { } }
                        }} // Disables auto focus on MenuItems and allows TextField to be in focus
                        inputProps={{
                            sx: { padding: '0 5px' }
                        }}
                        labelId="search-select-label"
                        IconComponent={KeyboardArrowDown}
                        id="pesq_cond_select"
                        onChange={handleChange}
                        onClose={() => setSearchText("")}
                        open={open}
                    >
                        <ListSubheader>
                            <TextField
                                size="small"
                                placeholder="Pesquisar..."
                                fullWidth
                                inputRef={(input) => {
                                    setTimeout(() => {
                                        if (input != null) {
                                            input.focus()
                                        }
                                    }, 300)
                                }}
                                onChange={(e) => setSearchText(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleKeyDown(e)
                                    }
                                    if (e.key !== "Escape") {
                                        // Prevents autoselecting item while typing (default Select behaviour)
                                        e.stopPropagation()
                                    }
                                }}
                            />
                        </ListSubheader>
                        <MenuItem key={`menu_combo_vazio`} value="">
                            Nenhuma opção
                        </MenuItem>
                        {displayedOptions.map((option, i) => (
                            <MenuItem sx={{ height: '30px' }} key={`menu_combo_${i}`} value={option[value]}>
                                <span style={{ width: "45px" }}>{option[value]}</span><span> - {option[label]}</span>
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </Box>
    )
}
